export default "﻿"